import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { ReportsRoutingModule } from './reports-routing.module';
import { SharedModule } from '../shared/shared.module';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';

import { ButtonModule } from 'primeng/button';
import { SelectModule } from 'primeng/select';
import { CardModule } from 'primeng/card';
import { MessageModule } from 'primeng/message';
import { CheckboxModule } from 'primeng/checkbox';
import { PanelModule } from 'primeng/panel';
import { TooltipModule } from 'primeng/tooltip';
import { TableModule } from 'primeng/table';
import { DatePickerModule } from 'primeng/datepicker';
import { ChartModule } from 'primeng/chart';
import { InputTextModule } from 'primeng/inputtext';
import { TabsModule } from 'primeng/tabs';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { DialogModule } from 'primeng/dialog';
import { MatIconModule } from '@angular/material/icon';
import { UiScrollModule } from 'ngx-ui-scroll';

import { AppleReenrollmentsComponent } from './components/apple-reenrollments/apple-reenrollments.component';

@NgModule({
  declarations: [
    AppleReenrollmentsComponent,
  ],
  imports: [
    SharedModule,
    ReportsRoutingModule,
    ReactiveFormsModule,
    FormsModule,
    ButtonModule,
    SelectModule,
    CardModule,
    MessageModule,
    CheckboxModule,
    PanelModule,
    TooltipModule,
    TableModule,
    DatePickerModule,
    ChartModule,
    InputTextModule,
    TabsModule,
    ConfirmDialogModule,
    DialogModule,
    MatIconModule,
    UiScrollModule,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class ReportsModule { }
